import {
	commissionsByID,
	commissionsList,
	deleteCommissionByID,
	newCommission,
	requestByID,
	requestCreate,
	requestDestroy,
	requestUpdate,
	requestsList,
	updateCommissions,
	documentByID,
	documentCreate,
	documentDestroy,
	documentUpdate,
	documentsList,
	affiliateUsersList,
	affiliateUserByID,
} from '@/services/affiliates.service'

export default {
	namespaced: true,

	state: {
		// AFFILIATE USERS
		affiliateUsersList: {
			meta: { pagination: { total: 0 } },
		},
		affiliateUser: {},
		affiliateUsersStatus: 'pending',

		// COMMISSIONS
		commissionsList: {
			meta: {
				pagination: {
					total: 0,
				},
			},
		},
		commission: {},
		commissionsStatus: 'init',
		commissionsSaveStatus: 'init',
		commissionsDeleteStatus: 'init',

		// REQUESTS
		requestsList: {
			meta: {
				pagination: {
					total: 0,
				},
			},
		},
		request: {},
		requestsStatus: 'pending',
		requestsSaveStatus: 'init',
		requestsDeleteStatus: 'init',

		// DOCUMENTS
		documentsList: {
			meta: {
				pagination: {
					total: 0,
				},
			},
		},
		document: {},
		documentsStatus: 'pending',
		documentsSaveStatus: 'init',
		documentsDeleteStatus: 'init',
	},

	getters: {
		getAffiliateUsersList: state => state.affiliateUsersList,
		getAffiliateUser: state => state.affiliateUser,
		getAffiliateUsersStatus: state => state.affiliateUsersStatus,

		getCommissionsList: state => state.commissionsList,
		getCommission: state => state.commission,
		getCommissionsStatus: state => state.commissionsStatus,
		getCommissionsSaveStatus: state => state.commissionsSaveStatus,
		getCommissionsDeleteStatus: state => state.commissionsDeleteStatus,

		// REQUESTS
		getRequestsList(state) {
			return state.requestsList
		},
		getRequests(state) {
			return state.request
		},
		getRequestsStatus(state) {
			return state.requestsStatus
		},
		getRequestsDeleteStatus(state) {
			return state.requestsDeleteStatus
		},
		getRequestsSaveStatus(state) {
			return state.requestsSaveStatus
		},

		// DOCUMENTS
		getDocumentsList(state) {
			return state.documentsList
		},
		getDocuments(state) {
			return state.document
		},
		getDocumentsStatus(state) {
			return state.documentsStatus
		},
		getDocumentsDeleteStatus(state) {
			return state.documentsDeleteStatus
		},
		getDocumentsSaveStatus(state) {
			return state.documentsSaveStatus
		},
	},

	mutations: {
		AFFILIATE_USERS_LIST(state, value) {
			state.affiliateUsersList = value
		},
		SET_AFFILIATE_USER(state, value) {
			state.affiliateUser = value
		},
		AFFILIATE_USERS_STATUS(state, value) {
			state.affiliateUsersStatus = value
		},

		COMMISSIONS_LIST(state, value) {
			state.commissionsList = value
		},
		SET_COMMISSION(state, value) {
			state.commission = value
		},
		COMMISSIONS_STATUS(state, value) {
			state.commissionsStatus = value
		},
		COMMISSIONS_SAVE_STATUS(state, value) {
			state.commissionsSaveStatus = value
		},
		COMMISSIONS_DELETE_STATUS(state, value) {
			state.commissionsDeleteStatus = value
		},

		// REQUESTS
		REQUESTS_LIST(state, value) {
			state.requestsList = value
		},
		SET_REQUEST(state, value) {
			state.request = value
		},
		REQUESTS_STATUS(state, value) {
			state.requestsStatus = value
		},
		REQUEST_SAVE_STATUS(state, value) {
			state.requestsSaveStatus = value
		},
		REQUEST_DELETE_STATUS(state, value) {
			state.requestsDeleteStatus = value
		},

		// DOCUMENTS
		DOCUMENTS_LIST(state, value) {
			state.documentsList = value
		},
		SET_DOCUMENT(state, value) {
			state.document = value
		},
		DOCUMENTS_STATUS(state, value) {
			state.documentsStatus = value
		},
		DOCUMENT_SAVE_STATUS(state, value) {
			state.documentsSaveStatus = value
		},
		DOCUMENT_DELETE_STATUS(state, value) {
			state.documentsDeleteStatus = value
		},
	},

	actions: {
		async fetchAffiliateUsers({ commit }, params) {
			window.scrollTo({ top: 0, behavior: 'smooth' })
			commit('AFFILIATE_USERS_STATUS', 'pending')
			commit('AFFILIATE_USERS_LIST', { meta: { pagination: { total: 0 } } })
			try {
				const { data } = await affiliateUsersList(params)
				commit('AFFILIATE_USERS_LIST', data)
				commit('AFFILIATE_USERS_STATUS', 'init')
				return data
			} catch (error) {
				commit('AFFILIATE_USERS_STATUS', 'init')
				throw error
			}
		},

		async fetchAffiliateUser({ commit }, id) {
			commit('AFFILIATE_USERS_STATUS', 'pending')
			try {
				const { data } = await affiliateUserByID(id)
				commit('SET_AFFILIATE_USER', data.data)
				commit('AFFILIATE_USERS_STATUS', 'init')
				return data
			} catch (error) {
				commit('AFFILIATE_USERS_STATUS', 'init')
				throw error
			}
		},

		async fetchCommissionsList({ commit }, params) {
			window.scrollTo({ top: 0, behavior: 'smooth' })
			commit('COMMISSIONS_STATUS', 'pending')
			commit('COMMISSIONS_LIST', {
				meta: { pagination: { total: 0 } },
			})

			try {
				const { data } = await commissionsList(params)
				commit('COMMISSIONS_LIST', data)
				commit('COMMISSIONS_STATUS', 'success')
				return data
			} catch (error) {
				commit('COMMISSIONS_STATUS', 'error')
				throw error
			}
		},

		async fetchCommissionByID({ commit }, params) {
			commit('COMMISSIONS_STATUS', 'pending')
			try {
				const { data } = await commissionsByID(params)
				commit('SET_COMMISSION', data.data)
				commit('COMMISSIONS_STATUS', 'success')
				return data
			} catch (error) {
				commit('COMMISSIONS_STATUS', 'error')
				this._vm.$root.$notify({
					message: error.response?.data?.message || 'Erro ao carregar comissão',
					type: 'danger',
				})
				throw error
			}
		},

		async saveNewCommission({ commit }, params) {
			commit('COMMISSIONS_SAVE_STATUS', 'pending')
			try {
				const { data } = await newCommission(params)
				commit('COMMISSIONS_SAVE_STATUS', 'success')
				return data
			} catch (error) {
				commit('COMMISSIONS_SAVE_STATUS', 'error')
				throw error
			}
		},

		async updateCommissions({ commit }, params) {
			commit('COMMISSIONS_SAVE_STATUS', 'pending')
			try {
				const { data } = await updateCommissions(params)
				commit('COMMISSIONS_SAVE_STATUS', 'success')
				return data
			} catch (error) {
				commit('COMMISSIONS_SAVE_STATUS', 'error')
				throw error
			}
		},

		async deleteCommissionByID({ commit }, params) {
			commit('COMMISSIONS_DELETE_STATUS', 'pending')
			try {
				const { data } = await deleteCommissionByID(params)
				commit('COMMISSIONS_DELETE_STATUS', 'success')
				return data
			} catch (error) {
				commit('COMMISSIONS_DELETE_STATUS', 'error')
				this._vm.$root.$notify({
					message: error.response?.data?.message || 'Erro ao deletar comissão',
					type: 'danger',
				})
				throw error
			}
		},

		// Requests
		async fetchRequestsList({ commit }, params) {
			window.scrollTo({ top: 0, behavior: 'smooth' })
			commit('REQUESTS_STATUS', 'pending')
			commit('REQUESTS_LIST', {
				meta: {
					pagination: {
						total: 0,
					},
				},
			})
			try {
				const { data } = await requestsList(params)
				commit('REQUESTS_STATUS', 'init')
				commit('REQUESTS_LIST', data)
				return data
			} catch (error) {
				commit('REQUESTS_STATUS', 'init')
				throw error
			}
		},
		async fetchRequestsByID({ commit }, params) {
			commit('REQUESTS_STATUS', 'pending')
			try {
				const { data } = await requestByID(params)
				commit('REQUESTS_STATUS', 'init')
				commit('SET_REQUEST', data.data)
				return data
			} catch (error) {
				commit('REQUESTS_STATUS', 'init')
				this._vm.$root.$notify({
					message: error.response.data.message,
					type: 'danger',
				})
				return error
			}
		},
		async saveNewRequests({ commit }, params) {
			commit('REQUEST_SAVE_STATUS', 'pending')
			try {
				const { data } = await requestCreate(params)
				commit('REQUEST_SAVE_STATUS', 'init')
				return data
			} catch (error) {
				commit('REQUEST_SAVE_STATUS', 'init')
				throw error
			}
		},
		async updateRequests({ commit }, params) {
			commit('REQUEST_SAVE_STATUS', 'pending')
			try {
				const { data } = await requestUpdate(params)
				commit('REQUEST_SAVE_STATUS', 'init')
				return data
			} catch (error) {
				commit('REQUEST_SAVE_STATUS', 'init')
				throw error
			}
		},
		async deleteRequestsByID({ commit }, params) {
			commit('REQUEST_DELETE_STATUS', 'pending')
			try {
				const { data } = await requestDestroy(params)
				commit('REQUEST_DELETE_STATUS', 'init')
				return data
			} catch (error) {
				commit('REQUEST_DELETE_STATUS', 'error')

				return error
			}
		},

		// Documents
		async fetchDocumentsList({ commit }, params) {
			window.scrollTo({ top: 0, behavior: 'smooth' })
			commit('DOCUMENTS_STATUS', 'pending')
			commit('DOCUMENTS_LIST', {
				meta: {
					pagination: {
						total: 0,
					},
				},
			})
			try {
				const { data } = await documentsList(params)
				commit('DOCUMENTS_STATUS', 'init')
				commit('DOCUMENTS_LIST', data)
				return data
			} catch (error) {
				commit('DOCUMENTS_STATUS', 'init')
				throw error
			}
		},
		async fetchDocumentsByID({ commit }, params) {
			commit('DOCUMENTS_STATUS', 'pending')
			try {
				const { data } = await documentByID(params)
				commit('DOCUMENTS_STATUS', 'init')
				commit('SET_DOCUMENT', data.data)
				return data
			} catch (error) {
				commit('DOCUMENTS_STATUS', 'init')
				this._vm.$root.$notify({
					message: error.response.data.message,
					type: 'danger',
				})
				return error
			}
		},
		async saveNewDocuments({ commit }, params) {
			commit('DOCUMENT_SAVE_STATUS', 'pending')
			try {
				const { data } = await documentCreate(params)
				commit('DOCUMENT_SAVE_STATUS', 'init')
				return data
			} catch (error) {
				commit('DOCUMENT_SAVE_STATUS', 'init')
				throw error
			}
		},
		async updateDocuments({ commit }, params) {
			commit('DOCUMENT_SAVE_STATUS', 'pending')
			try {
				const { data } = await documentUpdate(params)
				commit('DOCUMENT_SAVE_STATUS', 'init')
				return data
			} catch (error) {
				commit('DOCUMENT_SAVE_STATUS', 'init')
				throw error
			}
		},
		async deleteDocumentsByID({ commit }, params) {
			commit('DOCUMENT_DELETE_STATUS', 'pending')
			try {
				const { data } = await documentDestroy(params)
				commit('DOCUMENT_DELETE_STATUS', 'init')
				return data
			} catch (error) {
				commit('DOCUMENT_DELETE_STATUS', 'error')

				return error
			}
		},
	},
}
